module.exports = __webpack_public_path__ + "77d14b9108b54b7ef90a23359f844271.svg";